import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
const routes = [
  {
    path: '*',
    redirect: '/homeBefore'
    // redirect: to => {
    //   if (localStorage.getItem('version') === 'old') {
    //     return '/oldhome'
    //   } else {
    //     return '/home'
    //   }
    // }
  },
  // 首页
  {
    path: '/oldhome',
    redirect: '/home'
    // name: 'Home',
    // // 路由懒加载：https://router.vuejs.org/zh/guide/advanced/lazy-loading.html
    // // webpackPreload：https://www.jianshu.com/p/bbdcfeee7fbc
    // // component: () => import(/* webpackPreload: true */ '@/views/home'),
    // component: () => import(/* webpackPreload: true */ '@/views/portal'),
    // meta: {
    //   title: '首页',
    //   showTab: true
    //   // keepAlive: true
    // }
  },
  // 新首页
  {
    path: '/homeBefore',
    name: 'NewHome',
    component: () => import('@/views/portal/homeBefore.vue'),
    meta: {
      title: '首页'
    }
  },
  // 新首页
  {
    path: '/home',
    name: 'NewHome',
    component: () => import('@/views/portal/newHome.vue'),
    meta: {
      title: '新首页',
      showTab: true,
      keepAlive: true
    }
  },
  // 菜单
  // {
  //   path: '/menuList',
  //   name: 'MenuList',
  //   component: () => import('@/views/portal/menuList.vue'),
  //   meta: {
  //     title: '菜单'
  //   }
  // },
  // 设置筹码类型
  {
    path: '/setMonsType',
    name: 'NewHome',
    component: () => import('@/views/user/setMonsType.vue'),
    meta: {
      title: '设置筹码类型'
    }
  },
  // 菜单
  {
    path: '/backRate',
    name: 'BackRate',
    component: () => import('@/views/portal/backRate.vue'),
    meta: {
      title: '佣金奖励比例'
    }
  },
  // 设备管理
  {
    path: '/deviceManage',
    name: 'deviceManage',
    component: () => import('@/views/portal/recharge/deviceManage.vue'),
    meta: {
      title: 'VIP详情'
    }
  },
  // VIP详情
  {
    path: '/vipDetail',
    name: 'vipDetail',
    component: () => import('@/views/user/vipDetail.vue'),
    meta: {
      title: 'VIP详情'
    }
  },
  // 游戏iframe
  {
    path: '/iframeGame',
    name: 'iframeGame',
    component: () => import('@/views/portal/iframeGame.vue'),
    meta: {
      title: '游戏中'
    }
  },
  // 邀请好友
  {
    path: '/shareFriends',
    name: 'shareFriends',
    component: () => import('@/views/portal/shareFriends.vue'),
    meta: {
      title: '邀请好友'
      // showTab: true
    }
  },
  // 任务中心
  {
    path: '/taskCenter',
    name: 'taskCenter',
    component: () => import('@/views/taskCenter'),
    meta: {
      title: '任务中心'
    }
  },
  // 私钥验证
  {
    path: '/verifyIndex',
    name: 'VerifyIndex',
    component: () => import('@/views/portal/verifyIndex.vue'),
    meta: {
      title: '私钥验证'
    }
  },
  // 期号查询
  {
    path: '/searchMoreInfo',
    name: 'SearchMoreInfo',
    component: () => import('@/views/portal/detailView/searchMoreInfo.vue'),
    meta: {
      title: '期号查询'
    }
  },
  // 香港
  {
    path: '/gameHKlhc',
    name: 'GameHKlhc',
    component: () => import('@/views/portal/detailView/gameHKlhc.vue'),
    meta: {
      title: '加拿大网盘'
    }
  },
  // 加拿大网盘
  {
    path: '/gameCanada',
    name: 'GameCanada',
    component: () => import('@/views/portal/detailView/gameCanada.vue'),
    meta: {
      title: '加拿大网盘'
    }
  },
  {
    path: '/coinExchange',
    name: 'CoinExchange',
    component: () => import('@/views/portal/detailView/coinExchange.vue'),
    meta: {
      title: 'U本位永续合约'
    }
  },
  // 真心话大冒险
  {
    path: '/talkAdventure',
    name: 'TalkAdventure',
    component: () => import('@/views/tel/talkAdventure.vue'),
    meta: {
      title: '真心话大冒险'
    }
  },
  // tel充值
  {
    path: '/telRecharge',
    name: 'TelRecharge',
    component: () => import('@/views/tel/telRecharge.vue'),
    meta: {
      title: '充值'
    }
  },
  // 排行榜
  {
    path: '/compositor',
    name: 'Compositor',
    component: () => import('@/views/tel/compositor.vue'),
    meta: {
      title: '排行榜'
    }
  },
  // 财富排行榜
  {
    path: '/wealthRankings',
    name: 'WealthRankings',
    component: () => import('@/views/tel/wealthRankings.vue'),
    meta: {
      title: '排行榜'
    }
  },
  // 升级系统
  {
    path: '/upgradeSystem',
    name: 'UpgradeSystem',
    component: () => import('@/views/portal/upgradeSystem.vue'),
    meta: {
      title: '游戏页'
    }
  },
  // 切换线路
  {
    path: '/changeApiRoute',
    name: 'ChangeApiRoute',
    component: () => import('@/views/portal/changeApiRoute.vue'),
    meta: {
      title: '线路选择'
    }
  },
  {
    path: '/changeApiRoute1',
    name: 'ChangeApiRoute',
    component: () => import('@/views/portal/changeApiRoute.vue'),
    meta: {
      title: '线路选择1'
    }
  },
  {
    path: '/showPdf',
    name: 'ShowPdf',
    component: () => import('@/views/portal/inviteFriends/showPdf.vue'),
    meta: {
      title: '代理介绍'
    }
  },
  {
    path: '/showPdf1',
    name: 'ShowPdf1',
    component: () => import('@/views/portal/inviteFriends/showPdf1.vue'),
    meta: {
      title: '如何验证'
    }
  },
  // 玩法详情页
  {
    path: '/detailView',
    name: 'DetailView',
    component: () => import('@/views/portal/detailView/index.vue'),
    meta: {
      title: '详情页'
    }
  },
  // 投注记录页
  {
    path: '/orderRecord',
    name: 'OrderRecord',
    component: () => import('@/views/portal/orderRecord'),
    meta: {
      title: '投注记录'
    }
  },
  {
    path: '/orderRecordSummary',
    name: 'OrderRecord',
    component: () => import('@/views/portal/orderRecordSummary'),
    meta: {
      title: '投注记录汇总',
      keepAlive: true
    }
  },
  {
    path: '/rules',
    name: 'Rules',
    component: () => import('@/views/portal/rules.vue'),
    meta: {
      title: '游戏规则'
    }
  },
  {
    path: '/recharge',
    name: 'Recharge',
    component: () => import('@/views/portal/recharge/index.vue'),
    meta: {
      title: '充值'
    }
  },
  {
    path: '/hwrecharge/',
    name: 'HWrecharge',
    component: () => import('@/views/portal/recharge/HWrecharge.vue'),
    meta: {
      title: '汇旺充值'
    }
  },
  {
    path: '/rechargeDetail/',
    name: 'RechargeDetail',
    component: () => import('@/views/portal/recharge/rechargeDetail.vue'),
    meta: {
      title: '充值详情'
    }
  },
  {
    path: '/orderRecordDetail/',
    name: 'OrderRecordDetail',
    component: () => import('@/views/portal/orderRecordDetail.vue'),
    meta: {
      title: '投注记录详情'
    }
  },
  {
    path: '/addWalletAress',
    name: 'AddWalletAress',
    component: () => import('@/views/portal/recharge/addWalletAress.vue'),
    meta: {
      title: '添加地址'
    }
  },
  {
    path: '/reflect',
    name: 'Reflect',
    component: () => import('@/views/portal/recharge/reflect.vue'),
    meta: {
      title: '提现'
    }
  },
  {
    path: '/rechargeRecord',
    name: 'RechargeRecord',
    component: () => import('@/views/portal/recharge/rechargeRecord.vue'),
    meta: {
      title: '充提记录'
    }
  },
  {
    path: '/rechargeTutorial',
    name: 'RechargeTutorial',
    component: () => import('@/views/portal/recharge/rechargeTutorial.vue'),
    meta: {
      title: '充值教程'
    }
  },
  {
    path: '/inviteFriends',
    name: 'InviteFriends',
    component: () => import('@/views/portal/inviteFriends/index.vue'),
    meta: {
      title: '邀请好友'
    }
  },
  {
    path: '/partnernew',
    name: 'Partner',
    component: () => import('@/views/portal/inviteFriends/partner.vue'),
    meta: {
      title: '代理'
    }
  },
  {
    path: '/partner',
    name: 'Partner',
    component: () => import('@/views/portal/inviteFriends/partner.vue'),
    meta: {
      title: '代理',
      showTab: true
    }
  },
  {
    path: '/redbagRecord',
    name: 'RedbagRecord',
    component: () => import('@/views/portal/redbag/redbagRecord.vue'),
    meta: {
      title: '领取记录'
    }
  },
  {
    path: '/commisRecord',
    name: 'CommisRecord',
    component: () => import('@/views/portal/commisRecord.vue'),
    meta: {
      title: '佣金记录'
    }
  },
  {
    path: '/lowerRecord',
    name: 'LowerRecord',
    component: () => import('@/views/portal/lowerRecord.vue'),
    meta: {
      title: '下级流水记录'
    }
  },
  {
    path: '/redbag',
    name: 'Redbag',
    component: () => import('@/views/portal/redbag/index.vue'),
    meta: {
      title: '购买虚拟币'
    }
  },
  {
    path: '/pwdRedbag',
    name: 'PwdRedbag',
    component: () => import('@/views/portal/redbag/pwdRedbag.vue'),
    meta: {
      title: '口令红包'
    }
  },
  {
    path: '/verifyFairness',
    name: 'VerifyFairness',
    component: () => import('@/views/portal/verifyFairness.vue'),
    meta: {
      title: '验证公平'
    }
  },
  {
    path: '/performance_record',
    name: 'PerformanceRecord',
    component: () => import('@/views/portal/inviteFriends/PerformanceRecord.vue'),
    meta: {
      title: '代理/直属业绩'
    }
  },
  {
    path: '/prizeRecord',
    name: 'PrizeRecord',
    component: () => import('@/views/taskCenter/PrizeRecord.vue'),
    meta: {
      title: '抽奖券明细'
    }
  },
  {
    path: '/softwareDownload',
    name: 'SoftwareDownload',
    component: () => import('@/views/portal/softwareDownload.vue'),
    meta: {
      title: '相关软件下载'
    }
  },
  {
    path: '/report',
    name: 'Report',
    component: () => import('@/views/user/report.vue'),
    meta: {
      title: '输赢报表'
    }
  },
  {
    path: '/agentCenter',
    name: 'AgentCenter',
    component: () => import('@/views/user/agentCenter/index.vue'),
    meta: {
      title: '代理中心'
    }
  },
  {
    path: '/reportAgent',
    name: 'Report',
    component: () => import('@/views/user/agentCenter/reportAgent.vue'),
    meta: {
      title: '团队输赢报表'
    }
  },
  {
    path: '/agentDetail',
    name: 'AgentDetail',
    component: () => import('@/views/user/agentDetail.vue'),
    meta: {
      title: '团队输赢报表详情'
    }
  },
  {
    path: '/agentIntro',
    name: 'AgentIntro',
    component: () => import('@/views/user/agentCenter/agentIntro.vue'),
    meta: {
      title: '代理介绍'
    }
  },
  {
    path: '/teamReport',
    name: 'TeamReport',
    component: () => import('@/views/user/teamReport.vue'),
    meta: {
      title: '团队流水报表'
    }
  },
  {
    path: '/transRecord',
    name: 'TransRecord',
    component: () => import('@/views/user/transRecord.vue'),
    meta: {
      title: '交易记录'
    }
  },
  {
    path: '/failGame',
    name: 'FailGame',
    component: () => import('@/views/portal/failGame.vue'),
    meta: {
      title: '跳转失败'
    }
  },
  {
    path: '/agent',
    name: 'Agent',
    component: () => import('@/views/user/agent.vue'),
    meta: {
      title: '代理合作'
    }
  },
  {
    path: '/agentNew',
    name: 'Agent',
    component: () => import('@/views/user/agent.vue'),
    meta: {
      title: '代理合作',
      showTab: true
    }
  },
  {
    path: '/buyBit',
    name: 'BuyBit',
    component: () => import('@/views/user/buyBit.vue'),
    meta: {
      title: '购买虚拟币'
    }
  },
  {
    path: '/vip',
    name: 'Vip',
    component: () => import('@/views/vip/index.vue'),
    meta: {
      title: 'vip',
      showTab: true
    }
  },
  {
    path: '/activity',
    name: 'Activity',
    component: () => import('@/views/activity/index.vue'),
    meta: {
      title: 'activity',
      showTab: true
    }
  },
  {
    path: '/monthka',
    name: 'monthka',
    component: () => import('@/views/activity/monthka.vue'),
    meta: {
      title: '限时月卡'
    }
  },
  {
    path: '/safeCenter',
    name: 'SafeCenter',
    component: () => import('@/views/safe/safeCenter.vue'),
    meta: {
      title: '安全中心'
    }
  },
  {
    path: '/setAccount',
    name: 'SetAccount',
    component: () => import('@/views/safe/setAccount.vue'),
    meta: {
      title: '设置账号'
    }
  },
  {
    path: '/setMail',
    name: 'SetMail',
    component: () => import('@/views/safe/setMail.vue'),
    meta: {
      title: '设置邮箱'
    }
  },
  {
    path: '/editMail',
    name: 'EditMail',
    component: () => import('@/views/safe/editMail.vue'),
    meta: {
      title: '修改邮箱'
    }
  },
  {
    path: '/editLoginPsd',
    name: 'EditLoginPsd',
    component: () => import('@/views/safe/editLoginPsd.vue'),
    meta: {
      title: '修改登录密码'
    }
  },
  {
    path: '/editReflectPsd',
    name: 'EditReflectPsd',
    component: () => import('@/views/safe/editReflectPsd.vue'),
    meta: {
      title: '修改提现密码'
    }
  },
  {
    path: '/forgetLoginpwd',
    name: 'ForgetLoginpwd',
    component: () => import('@/views/safe/forgetLoginpwd.vue'),
    meta: {
      title: '忘记登录密码'
    }
  },
  {
    path: '/forgetDrawpwd',
    name: 'ForgetDrawpwd',
    component: () => import('@/views/safe/forgetDrawpwd.vue'),
    meta: {
      title: '忘记提现密码'
    }
  },
  {
    path: '/setReflectPsd',
    name: 'SetReflectPsd',
    component: () => import('@/views/safe/setReflectPsd.vue'),
    meta: {
      title: '提币地址管理'
    }
  },
  {
    path: '/luckyWheel',
    name: 'LuckyWheel',
    component: () => import('@/views/user/luckyWheel.vue'),
    meta: {
      title: '幸运大转盘'
    }
  },
  // {
  //   path: '/zcrw',
  //   name: 'Zcrw',
  //   component: () => import('@/views/activity/zcrw.vue'),
  //   meta: {
  //     title: '找茬任务'
  //   }
  // },
  // 登录
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/login'),
    meta: {
      title: '登录'
    }
  },
  // 注册
  {
    path: '/registry',
    name: 'Registry',
    component: () => import('@/views/auth/registry'),
    meta: {
      title: '注册'
    }
  },
  // 我的
  {
    path: '/user',
    name: 'User',
    component: () => import('@/views/user'),
    meta: {
      title: '我的',
      showTab: true
    }
  }
]

const router = new VueRouter({
  // 记录上个页面的滚动位置
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes
})

export default router
